module.exports = __webpack_public_path__ + "static/media/arrow-metrics.c48af6c9.svg";